import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

interface BlogTagListProps {
  tags: Array<string>
  /** Cap the visible chips; the remainder collapses into "+n". */
  max?: number
  variant?: 'primary' | 'neutral'
  className?: string
}

export function BlogTagList({
  tags,
  max,
  variant = 'neutral',
  className,
}: BlogTagListProps) {
  if (tags.length === 0) return null

  const visible = max ? tags.slice(0, max) : tags
  const hidden = tags.length - visible.length

  return (
    <ul className={cn('flex flex-wrap gap-1.5', className)}>
      {visible.map((tag) => (
        <li key={tag}>
          <Badge
            variant={variant}
            className="rounded-full px-2.5 font-mono font-medium tracking-normal transition-colors duration-300 ease-brisk"
          >
            {tag}
          </Badge>
        </li>
      ))}
      {hidden > 0 && (
        <li className="font-mono text-caption tabular-nums text-[var(--color-text-tertiary)]">
          +{hidden}
        </li>
      )}
    </ul>
  )
}
